import { DEFAULT_VIEW_PATH } from 'email-management-lib/Shared/constants/frameworkTable';
export default function getShouldHidePublishStatusFilter(state) {
  return !!state && [DEFAULT_VIEW_PATH.DRAFT, DEFAULT_VIEW_PATH.SCHEDULED, DEFAULT_VIEW_PATH.SENT].includes(
  //@ts-expect-error Argument of type 'string' is not assignable to parameter of type '"draft" | "scheduled" | "sent"'.
  state);
}